import app from 'flarum/forum/app';
app.initializers.add('val-ui-login-password-toggle', () => {
  function installToggle(input) {
    if (!input || input.dataset.valPasswordToggle === '1') return;
    const group = input.closest('.Form-group') || input.parentElement;
    if (!group) return;
    input.dataset.valPasswordToggle = '1';
    group.classList.add('ValPasswordField');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'Button Button--icon ValPasswordToggle';
    button.title = 'Afficher le mot de passe';
    button.setAttribute('aria-label', 'Afficher le mot de passe');
    button.setAttribute('aria-pressed', 'false');
    const eye = document.createElement('i');
    eye.className = 'icon fas fa-eye';
    eye.setAttribute('aria-hidden', 'true');
    button.appendChild(eye);
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const visible = input.type === 'text';
      input.type = visible ? 'password' : 'text';
      button.title = visible ? 'Afficher le mot de passe' : 'Masquer le mot de passe';
      button.setAttribute('aria-label', visible ? 'Afficher le mot de passe' : 'Masquer le mot de passe');
      button.setAttribute('aria-pressed', visible ? 'false' : 'true');
      eye.classList.toggle('fa-eye', visible);
      eye.classList.toggle('fa-eye-slash', !visible);
      input.focus({
        preventScroll: true
      });
      try {
        const end = input.value.length;
        input.setSelectionRange(end, end);
      } catch (_) {}
    });
    group.appendChild(button);
  }
  function scan() {
    document.querySelectorAll('input[name="password"]').forEach(installToggle);
  }
  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(scan);
  });
  const start = () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    scan();
  };
  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  }
});